import SectionLink from './SectionLink';

const MARQUEE_WORDS = ['INEVITABLE', 'FERAL', 'SHIPPED', '24/7', 'MUMBAI', 'AI-AUGMENTED', 'INEVITABLE', 'FERAL', 'SHIPPED', '24/7'];

const CAPABILITIES = [
  'iOS development', 'Trading platforms', 'AI systems',
  'Full-stack web', 'UI / UX design', 'Security & infra',
];

const STUDIO = [
  { name: 'Work', href: '#work' },
  { name: 'Process', href: '#process' },
  { name: 'Team', href: '#team' },
  { name: 'About', href: '#about' },
  { name: 'Apps', href: '/apps' },
  { name: 'Blog', href: '/blog' },
  { name: 'Contact', href: '#contact' },
];

const RedesignFooter = () => (
  <footer className="site-footer">
    <div className="r-wrap">
      <div className="footer-top">
        <div className="footer-mark">
          <div className="footer-glyph">
            <img src="/logo1.svg" alt="Feral Techlabs" className="footer-logo" />
          </div>
          <h2 className="footer-h">
            Engineering<br />
            <span className="r-gtxt">the unfair advantage.</span>
          </h2>
          <p className="footer-p">
            Eight specialists. One kennel. We build software that feels inevitable —
            from Mumbai, for the rest of the world.
          </p>
        </div>

        <div className="footer-cols">
          <div>
            <h4>Capabilities</h4>
            <ul>
              {CAPABILITIES.map((c) => (
                <li key={c}><SectionLink href="#capabilities">{c}</SectionLink></li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Studio</h4>
            <ul>
              {STUDIO.map((s) => (
                <li key={s.name}><SectionLink href={s.href}>{s.name}</SectionLink></li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Inbox</h4>
            <ul>
              <li><a href="mailto:jacob@feraltechlabs.co.in">jacob@feraltechlabs.co.in</a></li>
              <li><a href="mailto:tanushgupta@feraltechlabs.co.in">tanushgupta@feraltechlabs.co.in</a></li>
              <li>Mumbai, India</li>
              <li><span style={{ color: '#10b981' }}>● </span>Always on — 24/7</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-marquee r-marquee" aria-hidden="true">
        <div className="r-marquee-track">
          {MARQUEE_WORDS.map((w, i) => (
            <span key={i}>{w}<span className="mt-dot">●</span></span>
          ))}
        </div>
        <div className="r-marquee-track" aria-hidden="true">
          {MARQUEE_WORDS.map((w, i) => (
            <span key={i}>{w}<span className="mt-dot">●</span></span>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Feral Techlabs · All rights reserved</span>
        <span>Built by an AI-augmented team · Mumbai, India</span>
      </div>
    </div>
  </footer>
);

export default RedesignFooter;
